export enum costTrackerFields {
  NAME = 'name',
  START = 'start',
  COST_TYPE = 'type',
  COST_AFE = 'costAfe',
  COST_SUGGESTED = 'costSuggested',
  COST_ACTUAL = 'costActual',
  VARIANCE = 'variance',
  FINISH = 'finish',
  SEVERAL_OPERATIONS_COST = 'severalOperationsCost',
}
